export default {"src":"/_next/static/media/affiliate.db7a27a3.svg","height":411,"width":450};